import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './style.scss';
import { v4 as uuidv4 } from 'uuid';
import TallyTabLoading from '../tallyTabLoading';
/**
 *
 */
function StepInfo({
  step, loading, tallyIntegrationTabs,
}) {
  return (
    <div className="integration-step-info-wrapper">
      {loading
        ? <TallyTabLoading />
        : (
          <div style={{ marginTop: '20px' }}>
            {tallyIntegrationTabs.map((i) => (
              <div className="integration-step-info-status-wrapper" key={uuidv4}>
                <div className={`dot dot-grey ${ step === i.stepNumber ? 'dot-blue' : 'dot-green' }`} />
                <div className="integration-step-info-status-heading-active">
                  &nbsp;
                  {i.stepName}
                </div>
              </div>
            ))}
          </div>
        )}
    </div>
  );
}

const mapStateToProps = () => ({

});
const mapDispatchToProps = () => ({
});
StepInfo.propTypes = {
  step: PropTypes.any,
  loading: PropTypes.bool,
  tallyIntegrationTabs: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(StepInfo));
